import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import FormSimple from "@components/formGroup/formSimple";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import IconInfo from "@image/icones/DocumentsEmployers/iconInfo.svg";
import { formatNethrisVal } from "@helpers/_functions";


function BalanceEmployeeBank({ employeebank, hoursPerDay,  labelTolltip = false, Title = "" }) {
  const { t, i18n } = useTranslation("pages.employés.emploi&Salary");

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      arrow
    />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#3F3F51",
      color: "#fff",
      fontSize: "12px",
      maxWidth: "358px",
      fontFamily: "Poppins_Medium",
      padding: "20px"
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: "#292929" // La couleur de la flèche
    }
  }));

  const designation = useMemo(() => {
    return i18n?.language === "en" ? employeebank?.designationEn : employeebank?.designationFr;
  }, [i18n?.language, employeebank?.designationEn, employeebank?.designationFr]);

  const category = useMemo(() => {
    return i18n?.language === "en" ? employeebank?.categoryEn : employeebank?.categoryFr;
  }, [i18n?.language, employeebank?.categoryFr, employeebank?.categoryEn]);

  // const banlanceHours = useMemo(() => {
  //   let decreaseHours = 0;
  //   if (employeebank?.conges?.length) {
  //     let days = 0;
  //     let hours = 0;
  //     for (let conge of employeebank?.conges) {
  //       if (conge.day) {
  //         days += isNaN(conge.day) ? 0 : conge.day;
  //       }
  //       if (conge.hour) {
  //         hours += isNaN(conge.hour) ? 0 : conge.hour;
  //       }
  //     }
  //     decreaseHours = days * hoursPerDay + hours;
  //   }
  //   if (employeebank?.BALANCE_HOURS) {
  //     return convertToNumber(employeebank.BALANCE_HOURS) - decreaseHours;
  //   }
  // }, [employeebank?.BALANCE_HOURS, employeebank?.conges])

  const balanceHours = useMemo(() => {
    let balanceHours = employeebank.BALANCE_HOURS;
    const hasBalance = balanceHours || employeebank?.BALANCE_AMOUNT;
    if (hasBalance && employeebank?.nethrisFormatVisible) {
      const { formattedVal } = formatNethrisVal(employeebank, employeebank, hoursPerDay)
      balanceHours = formattedVal;
    }
    return balanceHours;
  }, [
    employeebank?.BALANCE_HOURS,
    employeebank?.BALANCE_AMOUNT,
    employeebank?.EMPLOYEE_RATE,
    employeebank?.nethrisFormatReceived,
    employeebank?.nethrisFormatVisible,
    hoursPerDay
  ])

  return (
    <div className="arh-w-full arh-flex arh-items-end arh-justify-between">
      <div className="arh-relative arh-mb-1 arh-w-[25.5%] arh-flex arh-flex-col arh-mr-[4%]">
      {labelTolltip && Title && (
        <div className="arh-absolute arh-top-0 arh-right-0 arh-mt-[-0.5rem] arh-mr-2">
          <CustomTooltip title={Title} placement="top-end">
            <img src={IconInfo} alt="" className="arh-cursor-pointer" />
          </CustomTooltip>
        </div>
      )}
        <FormSimple
          label={designation}
          placeholder="0.00"
          ParentForm="arh-mb-[1.75rem]"
          classLabel="arh-flex"
          // value={banlanceHours < 0 ? 0 : banlanceHours}
          value={balanceHours}
          readOnly={true}
        />
      </div>
      <div className="arh-w-[25.5%] arh-flex arh-flex-col arh-mx-[4%]">
        <FormSimple
          label={`${t("Heures payées")} - ${category} (${t("période de référence")})`}
          placeholder="0.00"
          ParentForm="arh-mb-[1.75rem]"
          classLabel="arh-flex"
          value={employeebank?.PAID_HOURS}
          readOnly={true}
        />
      </div>
      <div className="arh-w-[25.5%] arh-flex arh-flex-col arh-mr-[4%]">
        <FormSimple
          label={`${t("Montant payé")} - ${category} (${t("période de référence")})`}
          placeholder="0.00"
          ParentForm="arh-mb-[1.75rem]"
          classLabel="arh-flex"
          value={employeebank?.PAID_AMOUNT}
          readOnly={true}
        />
      </div>
    </div>
  )
}

export default BalanceEmployeeBank;
